import { createContext, useContext } from "react";
import useExperiment from "../../hooks/useExperiment";
import { EXPERIMENT_KEYS } from "../../services/experiments";

const VisitMarginExperimentContext = createContext(null);

// Match the existing sitewide experiment owner: enroll as soon as SessionProvider
// supplies the stable visitor identity, independently of routes or pricing views.
export function VisitMarginExperimentProvider({ children }) {
  const experiment = useExperiment(EXPERIMENT_KEYS.visitMarginV1, {
    autoPersist: true,
    autoTrackExposure: false,
    surface: "app_root",
  });
  return <VisitMarginExperimentContext.Provider value={experiment}>{children}</VisitMarginExperimentContext.Provider>;
}

export const useVisitMarginExperiment = () => useContext(VisitMarginExperimentContext);
